var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lost-page"},[_c('div',{staticClass:"ufo"}),_c('div',{staticClass:"light"}),_c('div',{staticClass:"text"},[_c('i',{staticClass:"zero"})]),_c('div',{staticClass:"shadow"}),_c('p',[_c('span',[_vm._v("页面也许被请去喝茶了...")])])])
}]

export { render, staticRenderFns }